import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {selectFeatureFlag} from 'App/features/featureFlags/featureFlagsSlice';
import {selectUserCredentials} from 'App/features/user/userSlice';
import initDatadogRum from 'App/monitoring/datadogRum';
import getConfig from '~/load_config';

import AppView from './app_view';

export default function AppContainer({children}) {
  const credentials = useSelector(selectUserCredentials);
  const isRedesignAvailable = useSelector(
    selectFeatureFlag('isRedesignAvailable'),
  );

  // Move font-family to base.css when isRedesignAvailable is removed
  // and remove redesign-available class
  useEffect(() => {
    if (isRedesignAvailable) {
      document.body.style.fontFamily = 'Sora';
      document.body.classList.add('redesign-available');
    } else {
      document.body.style.fontFamily =
        'noto-sans-display, aktiv-grotesk, sans-serif';
      document.body.classList.remove('redesign-available');
    }
  }, [isRedesignAvailable]);

  useEffect(() => {
    const config = getConfig();
    initDatadogRum(
      config,
      credentials.user.email,
      credentials.organization.name,
    );
  }, [credentials]);

  return <AppView>{children}</AppView>;
}
